var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7318 3.87C12.962 2.53667 11.0375 2.53667 10.2677 3.87L2.04046 18.12C1.27066 19.4533 2.23291 21.12 3.77251 21.12H20.227C21.7666 21.12 22.7288 19.4533 21.959 18.12L13.7318 3.87ZM12.2498 8.87C12.664 8.87 12.9998 9.15781 12.9998 9.51285V14.2271C12.9998 14.5822 12.664 14.87 12.2498 14.87C11.8356 14.87 11.4998 14.5822 11.4998 14.2271V9.51285C11.4998 9.15781 11.8356 8.87 12.2498 8.87ZM12.9998 16.4325C12.9998 16.1218 12.664 15.87 12.2498 15.87C11.8356 15.87 11.4998 16.1218 11.4998 16.4325V16.8075C11.4998 17.1182 11.8356 17.37 12.2498 17.37C12.664 17.37 12.9998 17.1182 12.9998 16.8075V16.4325Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.317b086396668254588f4ea2164e1329.svg";
export { ForwardRef as ReactComponent };